<template>
    <div class="relative">
        <a :href="modelValue" target="_blank" class="block underline truncate hover:no-underline" :class="[sizeClass]">
            {{ modelValue }}
        </a>

        <div v-if="props.valid" class="absolute text-green-800 -translate-y-1/2 top-1/2 right-4">
            <icon icon="hero/outline/check" class="w-4 h-4"></icon>
        </div>

        <div v-if="props.invalid" class="absolute text-red-800 -translate-y-1/2 top-1/2 right-4">
            <icon icon="hero/outline/exclamation-circle" class="w-4 h-4"></icon>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ComponentSize } from '@src/Common/DataGrid/types';

defineOptions({
    inheritAttrs: false,
});

const modelValue = defineModel({
    type: [String, undefined],
});

interface Props {
    placeholder?: string | undefined;
    size?: ComponentSize;
    dusk?: string | null;
    valid?: boolean;
    invalid?: boolean;
    required?: boolean;
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    placeholder: undefined,
    size: 'base',
    dusk: null,
    valid: false,
    invalid: false,
});

const sizeClass = computed(() => {
    return {
        'text-xs': props.size === 'xs',
        'text-sm': props.size === 'sm' || props.size === 'base',
        'text-lg': props.size === 'lg',
        'text-xl': props.size === 'xl',
    };
});
</script>
